var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"footer_link_item"},on:{"click":_vm.onClick}},[_c('button',{staticClass:"hyperlinkButton"},[_c('img',{attrs:{"src":require('@/images/icons/' + _vm.myImagename + '')}}),_vm._v("\n        "+_vm._s(_vm.myText)+"\n    ")])])}
var staticRenderFns = []

export { render, staticRenderFns }